module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1800-48.061136de.svg";